module.exports = __webpack_public_path__ + "static/media/service2.ab027f0f.jpeg";